import { MaintenanceAttachment } from '../services';
import { Employee } from '@fc-core/models/user.model';

export enum MaintenanceAlertStatus {
  RUNNING = 0,
  COMPLETED = 1,
  CLOSED = 2,
}

export interface MaintenanceAlert {
  id: number;
  progress: number;
  created: Date;
  modified: Date;
  status: number;
  current: number;
  firstAlert: boolean;
  lastProcessed: Date;
  completedAt?: any;
  closedAt: Date;
  notes: string;
  files: MaintenanceAttachment[];
  closedEngineHours?: number;
  closedOdometer?: number;
  schedule: number;
  closedBy: Employee;
  startEngineHours: number;
  startOdometer: number;
}

export interface MaintenanceDashboard
  extends Omit<MaintenanceAlert, 'schedule'> {
  schedule: {
    active: boolean;
    basedOn: string;
    created: Date;
    createdBy: string;
    id: number;
    max: number;
    modified: Date;
    name: string;
    sendNotification: boolean;
    startingPoint: number;
    vehicle: number;
    vehicleIdentifier: string;
  };
}
